export enum ActionTypes {
  fetchAllContent = 'fetchAllContent',
  fetchAllContentResolved = 'fetchAllContent_RESOLVED',
  fetchAllContentRejected = 'fetchAllContent_REJECTED',
}



// WEBPACK FOOTER //
// ./src/actions/actionTypes.ts